// extracted by css-extract-rspack-plugin
export default {"shimmer":"_a8eba826","shimmerLoadingBackground":"_1e99dc0e","placeholder":"_c778ae20"};